import { useMemo } from 'react';

import { useIRSConstants } from '@/modules/irs/useIRSConstants';
import { EntitySummaryGrantor } from '@/modules/presentation/entities/entityPresentations.types';
import { StateCode } from '@/types/schema';

export function useEntityGrantors(
  entity:
    | {
        household: {
          possiblePrimaryClients: PossiblePrimaryClient[] | null | undefined;
        };
      }
    | null
    | undefined
): EntitySummaryGrantor[] {
  const { availableStateEstateTaxes } = useIRSConstants();
  const grantors = useMemo<EntitySummaryGrantor[]>(() => {
    if (!entity) {
      return [];
    }
    return getEntityGrantors(
      entity?.household.possiblePrimaryClients ?? [],
      availableStateEstateTaxes
    );
  }, [availableStateEstateTaxes, entity]);
  return grantors;
}

interface PossiblePrimaryClient {
  id: string;
  displayName: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  address?:
    | {
        stateCode: string | undefined;
      }
    | null
    | undefined;
}

export function getEntityGrantors(
  possiblePrimaryClients: PossiblePrimaryClient[] | null | undefined,
  availableStateEstateTaxes?: StateCode[] | null | undefined
): EntitySummaryGrantor[] {
  return (
    possiblePrimaryClients?.map((grantor) => ({
      displayName: grantor.displayName,
      id: grantor.id,
      firstName: grantor.firstName,
      lastName: grantor.lastName,
      stateCode: grantor.address?.stateCode
        ? (grantor.address.stateCode as StateCode)
        : undefined,
      hasStateTax: grantor.address?.stateCode
        ? (availableStateEstateTaxes?.includes(
            grantor.address.stateCode as StateCode
          ) ?? false)
        : false,
    })) ?? []
  );
}
